import { getCookie } from 'cookies-next/client'

import { COOKIE_ECONDA_VISITOR_ID_NAME } from './cookieNames'

export const cookiesGetEcondaVisitorId = (): string | undefined =>
  getCookie(COOKIE_ECONDA_VISITOR_ID_NAME)?.split(':', 1)[0]
